import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

function fmt(ms) {
  if (ms < 0) ms = 0;
  const total = Math.floor(ms / 1000);
  const m = String(Math.floor(total / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");
  return `${m}:${s}`;
}

export function SessionTimer() {
  const { expiresAt } = useAuth();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!expiresAt) return null;
  const remaining = new Date(expiresAt).getTime() - now;
  const warning = remaining < 2 * 60 * 1000;
  return (
    <div
      className={`hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full border ${warning ? "border-red-300 bg-red-50" : "border-emerald-200 bg-emerald-50"}`}
      data-testid="session-timer"
    >
      <span
        className={`h-2 w-2 rounded-full animate-pulse-dot ${warning ? "bg-red-500" : "bg-emerald-500"}`}
        aria-hidden="true"
      />
      <span className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">Session</span>
      <span className={`font-mono-num text-sm font-semibold ${warning ? "text-red-700" : "text-emerald-700"}`}>
        {fmt(remaining)}
      </span>
    </div>
  );
}
